import React from 'react';
import PropTypes from 'prop-types';

import Moment from 'moment';
import { extendMoment } from 'moment-range';

import { withStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';

import DatepickerDay from './DatepickerDay';

const moment = extendMoment(Moment);

const styles = () => ({
  root: {
    height: 38,
  },
});

const DatepickerWeek = (props) => {
  const {
    classes,
    range,
    date,
    startDate,
    endDate,
    week,
    currentMonthNumber,
    minDate,
    maxDate,
    onDateSelect,
    onDayBlur,
    onDayMouseOver,
    onDayMouseOut,
    activeDate,
    disableTabFocus,
  } = props;

  return (
    <TableRow className={classes.root}>
      {week.map(day => (
        <DatepickerDay
          key={day.toString()}
          day={day}
          hidden={day.get('month') !== currentMonthNumber}
          disabled={
            (day.isBefore(minDate.startOf('day'))) ||
            (day.isAfter(maxDate.startOf('day')))
          }
          active={
            !range ? (date && date.clone().startOf('day').isSame(day, 'day')) :
              (
                (startDate && startDate.clone().startOf('day').isSame(day, 'day'))
                || (endDate && endDate.clone().startOf('day').isSame(day, 'day'))
              )
          }
          inRange={
            range
            && (startDate && day.isAfter(startDate.startOf('day')))
            && (endDate && day.isBefore(endDate.startOf('day')))
          }
          inActiveRange={
            activeDate
            && range
            && ((startDate && day.isBefore(activeDate.startOf('day')) && day.isAfter(startDate.startOf('day')))
              || (endDate && !startDate && day.isAfter(activeDate.startOf('day')) && day.isBefore(endDate.startOf('day')))
            )
          }
          today={moment().startOf('day').isSame(day, 'day')}
          onSelect={onDateSelect}
          onBlur={onDayBlur}
          onMouseOver={() => onDayMouseOver(day)}
          onMouseOut={() => onDayMouseOut(day)}
          disableTabFocus={disableTabFocus}
        />
      ))}
    </TableRow>
  );
};

DatepickerWeek.propTypes = {
  range: PropTypes.bool,
  date: PropTypes.instanceOf(Moment),
  startDate: PropTypes.instanceOf(Moment),
  endDate: PropTypes.instanceOf(Moment),
  week: PropTypes.arrayOf(PropTypes.instanceOf(Moment)).isRequired,
  currentMonthNumber: PropTypes.number.isRequired,
  minDate: PropTypes.instanceOf(Moment).isRequired,
  maxDate: PropTypes.instanceOf(Moment).isRequired,
  onDateSelect: PropTypes.func,
  onDayBlur: PropTypes.func,
  onDayMouseOver: PropTypes.func,
  onDayMouseOut: PropTypes.func,
  activeDate: PropTypes.instanceOf(Moment),
  disableTabFocus: PropTypes.bool.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

DatepickerWeek.defaultProps = {
  range: false,
  date: null,
  startDate: null,
  endDate: null,
  onDateSelect: () => {},
  onDayBlur: () => {},
  onDayMouseOver: () => {},
  onDayMouseOut: () => {},
  activeDate: null,
};

export default withStyles(styles)(DatepickerWeek);



// WEBPACK FOOTER //
// ./src/components/fields/DatepickerField/DatepickerWeek.js